import styles from "./DrawCard.module.scss";
import { DrawMemberStatus, DrawMethod, DrawType, IDraw } from "../../pages/DrawPage/DrawItem";
import { getTimeLeft, now, unixToDrawString } from "../../utils/time";
import { DrawDate } from "./DrawDate/DrawDate";
import prizeIcon from "./icons/prize.png";
//import nyPrizeIcon from "./icons/ny-prize.png";
import presentIcon from "./icons/present.png";
import { FC, useEffect, useState, MouseEvent } from "react";
import { trueMembersForm, truePrizesForm, trueTicketForm } from "../../utils/true.word.form";
import { useDrawNavigate } from "../../hooks/navigate";
import { DrawButton } from "./DrawButton/DrawButton";
import { DrawContext } from "../../pages/DrawPage/DrawRoutes";
import { IBalances } from "../../types/balances";
import { SliderButton } from "./SliderButton/SliderButton";
import { useDispatch, useSelector } from "../../hooks";
import { setCurrentRating } from "../../redux/ratings";
import { RatingType } from "../../redux/ratings/get-ratings.handler";
import { AssetsContext } from "../../pages/AssetsPage/AssetsTypes";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../Menu/MenuButton";
import { Fragment } from "../Fragment/Fragment";

export enum DrawStateDescription {
    Available = "Принять участие",
    Member = "Вы участвуете в розыгрыше",
    Confirm = "Подтвердите получение",
    Awarding = "Поздравляем, скоро отправим Вам подарок",
    Expired = "Вы не успели подтвердить получение подарка",
    Denied = "Вы не успели записаться на розыгрыш",
    Finished = "Розыгрыш закончился"
}

export enum DrawState {
    Available = 'available',
    Member = 'member',    
    Confirm = 'confirm',
    Awarding = 'awarding',
    Expired = 'expired',
    Finished = 'finished',
    Denied = 'denied',
}

export const getDrawStateDescription = (draw: IDraw): string => {
    switch (draw.userStatus) {
        case DrawMemberStatus.Member: {
            const weight = draw.method === DrawMethod.Automatic ? ` (${draw.userWeight} ${trueTicketForm(draw.userWeight)})` : '';
            return `${DrawStateDescription.Member}${weight}`;
        }

        case DrawMemberStatus.Winner:
        case DrawMemberStatus.Confirmed: return DrawStateDescription.Awarding;        

        case DrawMemberStatus.Candidate: return DrawStateDescription.Confirm;
        case DrawMemberStatus.Expired: return DrawStateDescription.Expired;
        case DrawMemberStatus.Finished: return DrawStateDescription.Finished;

        case DrawMemberStatus.None: {
            return !draw.confirmTimeoutDate && draw.operDate > now()
                ? DrawStateDescription.Available
                : DrawStateDescription.Denied;
        }
    }
}

export const getDrawState = (draw: IDraw): DrawState => {
    switch (draw.userStatus) {
        case DrawMemberStatus.Member: return DrawState.Member;    
        case DrawMemberStatus.Winner:
        case DrawMemberStatus.Confirmed: return DrawState.Awarding        

        case DrawMemberStatus.Candidate: return DrawState.Confirm;
        case DrawMemberStatus.Finished: return DrawState.Finished;        
        case DrawMemberStatus.Expired: return DrawState.Expired;

        case DrawMemberStatus.None: {
            return !draw.confirmTimeoutDate
                ? DrawState.Available
                : DrawState.Denied;
        }
    }
}

interface IDrawCardProps {
    draw: IDraw;
    handler?: (event: MouseEvent<HTMLButtonElement>, amount: number) => void;
}

export const DrawCard: FC<IDrawCardProps> = ({ draw, handler }) => {
    const [timeLeft, setTimeLeft] = useState(0);
    const fragmentsPrizes = useSelector(store => store.draws.fragmentsPrizes);
    const drawNavigate = useDrawNavigate();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (draw.userStatus === DrawMemberStatus.None || draw.userStatus === DrawMemberStatus.Member)
            setTimeLeft(draw.operDate);
        else if (draw.userStatus === DrawMemberStatus.Candidate)
            setTimeLeft(draw.confirmTimeoutDate);
    }, [draw.userStatus, draw.confirmTimeoutDate, draw.operDate]);

    const getIcon = () => {
        switch (draw.drawId) {
            //case 94: return nyPrizeIcon;
            default: return prizeIcon;
        }
    }

    const getTimeLeftText = () => {
        if (timeLeft > now())
            return `Осталось: ${getTimeLeft(timeLeft, -1)}`;

        return 'Идёт розыгрыш';
    }

    const getInfo = () => {
        return (
            <div className={`${styles.footer} ${styles[DrawType[draw.type].toLowerCase()]}`}>
                <span className={styles.alert}>{getDrawStateDescription(draw)}</span>
            </div>
        );
    }    

    const getButton = (cost?: IBalances) => {
        return (
            <DrawButton
                caption={ getDrawStateDescription(draw) }
                amount={ 1 }
                cost={ cost }
                handler={ (event) => handler!(event, 1) }
                drawState={ getDrawState(draw) }
                type={ draw.type }
            />
        );
    }

    const getControl = () => {
        switch (getDrawState(draw)) {
            case DrawState.Available:
                if (draw.operDate < now())
                    return getInfo();

                return draw.method === DrawMethod.Interactive
                    ? getButton(draw.cost)
                    : <SliderButton draw={ draw } handler={ handler! } />

            case DrawState.Confirm: return getButton();
            default: return getInfo();
        }
    }

    const isInteractive = () => draw.method === DrawMethod.Interactive;

    const onRatingHandle = (drawType: DrawType) => {
        let rating: RatingType | null = null;
        switch (drawType) {
            case DrawType.Rare: rating = RatingType.RareDrawLuck; break;
            case DrawType.Epic: rating = RatingType.EpicDrawLuck; break;
            case DrawType.Legendary: rating = RatingType.LegendaryDrawLuck; break;
        }

        if (!rating)
            return;

        dispatch(setCurrentRating(rating));
        navigate(`/${AppContext.Assets}/${AssetsContext.Ratings}`);
    }

    return (
        <div className={styles.giftCard} style={{ backgroundImage: `${'gray'}` }} >
            <div
                className={ `${styles.header} ${styles[DrawType[draw.type].toLowerCase()]}` }
            >
                <div className={ styles.headerTop } >
                    <img src={ getIcon() } alt="Prize Icon" className={styles.prizeIcon} />
                    <span>{ draw.prizeName }</span>
                </div>
            </div>

            <div className={styles.details}>
                <div className={styles.midBlock}>
                    <div className={styles.mainInfo}>
                        <div className={styles.leftBlock}>
                            <span className={`${styles.drawChar} ${styles.prizes}`}>
                                <span className={ `${styles.count} ${draw.prizeCount > 5 ? styles.contrast : ''}` }>{draw.prizeCount}</span>
                                <span> {truePrizesForm(draw.prizeCount)}</span>
                                { isInteractive() === true &&
                                    <div className={ styles.fragments } >
                                        <span>+ </span>
                                        <Fragment small={true} amount={fragmentsPrizes} />
                                    </div>
                                }
                            </span>

                            <span className={styles.drawChar}>
                                <span className={styles.count}>{draw.membersCount}</span>
                                <span> {trueMembersForm(draw.membersCount)}</span>
                            </span>
                        </div>

                        <div className={styles.cost}>
                            <DrawDate drawDate={ unixToDrawString(draw.operDate) } timeSubText={ getTimeLeftText() } />
                        </div>                        
                    </div>

                    { getControl() }

                    <div className={styles.bottom}>
                        <div
                            className={styles.conditionsButton}
                            onClick={ () => drawNavigate(DrawContext.Detail, draw.drawId) }
                        >
                            <img src={presentIcon} aria-label="gift" />
                            Условия розыгрыша
                        </div>

                        { !isInteractive() &&
                            <div
                                className={`${styles.rating} ${styles[DrawType[draw.type].toLowerCase()]}`}
                                onClick={ () => onRatingHandle(draw.type) }
                            >
                                Рейтинг удачи
                            </div>
                        }
                    </div>
                </div>
            </div>            
        </div>
    );
}
